<template>

    <tr :class="{ 'row-locked': rowDisabled }" role="radiogroup" :aria-labelledby="rowID">
        <td><span v-once v-html="choice.label" :id="rowID"></span></td>
        <td v-for="(column, index) of columns" :key="index" :class="{ 'col-locked': isColumnDisabled(column.value) }">
            <input
                type="radio"
                class="radio-input"
                v-if="!isHidden(column.value)"
                :name="uukey + '-' + row"
                :value="column.value"
                :checked="isSelected(column.value)"
                :disabled="rowDisabled || readOnly || isColumnDisabled(column.value)"
                @change.stop="changeValue"
                :tabindex="questionIndex"
                :aria-label="column.label"
            >
        </td>
    </tr>

</template>


<script>
import { isObject, isArray, isNil, has, includes } from 'lodash';
import { matrixRowMixin } from './mixins/matrix-row-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';

export default {
    name: 'matrix-2d-exclusive-row',

    mixins:[
        matrixRowMixin,
        matrixColumnsMixin,
    ],

    methods: {
        changeValue($event)
        {
            this.$parent.changeValue($event.target.value, this.choice.row);
        },

        isSelected(columnValue)
        {
            if (isNil(this.rowAnswer))
            {
                return false;
            }
            return this.rowAnswer == columnValue;
        },

        isHidden(colValue)
        {
            if (has(this.choice, 'except') && isArray(this.choice.except))
            {
                return (includes(this.choice.except, colValue));
            }

            return false;
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-2d-exclusive-row.vue